var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignatureLogoSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00A157;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    className: "st0",
    d: "M21.986,11.172c-2.407,0-4.358,1.951-4.358,4.358s1.951,4.358,4.358,4.358 s4.358-1.951,4.358-4.358l0,0C26.322,13.132,24.383,11.194,21.986,11.172z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    className: "st0",
    d: "M26.641,59.701c1.089,0.099,2.179,0.198,3.169,0.198c16.513,0.105,29.985-13.196,30.09-29.709 S46.703,0.206,30.19,0.101S0.206,13.297,0.101,29.81C0.01,44.107,10.053,56.467,24.066,59.305 M34.267,52.967 c4.061-4.754,10.201-12.083,12.479-15.252c1.276-1.59,1.88-3.616,1.684-5.645c-0.278-1.462-1.09-2.768-2.278-3.664 c-0.792-0.594-10.894-8.319-12.974-9.508c-0.623-0.39-1.344-0.596-2.08-0.594c-1.247,0-2.421,0.587-3.169,1.585l0,0 c-1.358,1.699-1.092,4.174,0.594,5.546l0,0c0.495,0.495,4.16,3.962,7.329,6.933c2.377,2.179,0.198,5.051,0,5.348l-0.099,0.099 l-9.409,15.351c-12.75-1.871-21.57-13.723-19.7-26.473s13.723-21.57,26.473-19.7s21.57,13.723,19.7,26.473 C51.383,43.236,43.954,51.047,34.267,52.967z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureLogoSolid);
export default __webpack_public_path__ + "static/media/signature_logo_solid.1ebef566.svg";
export { ForwardRef as ReactComponent };